import Video, { VideoProps, VIDEO_LOADING_TYPE, VIDEO_PRELOAD_TYPE } from './Video'
export { VideoProps, VIDEO_LOADING_TYPE, VIDEO_PRELOAD_TYPE }
export default Video
